'use client';

import { c as _c } from "react/compiler-runtime";
import { type EmoticonFilterState, useEmoticonFilterStore } from '@module/stores/useEmoticonFilterStore';
import ToggleButton from '@pc/components/atoms/button/ToggleButton';
import { useEffect } from 'react';
const HeartTabList = ['all', '1~3,000', '3,000~5,000', '5,000~10,000', '10,000~30,000', '30,000 이상'];
const parseHeartCategory = (label: string): EmoticonFilterState['heartCategory'] => {
  switch (label) {
    case '1~3,000':
      return '1-3000';
    case '3,000~5,000':
      return '3000-5000';
    case '5,000~10,000':
      return '5000-10000';
    case '10,000~30,000':
      return '10000-30000';
    case '30,000 이상':
      return '30000-';
    default:
      return 'all';
  }
};
const SignatureEmoticonFilterToggles = () => {
  const $ = _c(13);
  const heartCategory = useEmoticonFilterStore(_temp);
  const minHeart = useEmoticonFilterStore(_temp2);
  const maxHeart = useEmoticonFilterStore(_temp3);
  const setState = useEmoticonFilterStore(_temp4);
  const resetFilters = useEmoticonFilterStore(_temp5);
  let t0;
  if ($[0] !== heartCategory || $[1] !== maxHeart || $[2] !== minHeart || $[3] !== setState) {
    t0 = item => {
      const parsedHeartCategory = parseHeartCategory(item);
      const isOnSearchingHeartByInput = minHeart !== "" || maxHeart !== "";
      if (isOnSearchingHeartByInput) {
        setState("minHeart", "");
        setState("maxHeart", "");
        setState("minHeartInputValue", "");
        setState("maxHeartInputValue", "");
      }
      setState("heartCategory", parsedHeartCategory);
      if (parsedHeartCategory !== heartCategory) {
        setState("page", 1);
      }
    };
    $[0] = heartCategory;
    $[1] = maxHeart;
    $[2] = minHeart;
    $[3] = setState;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const handleClickHeartTab = t0;
  let t1;
  if ($[5] !== resetFilters) {
    t1 = () => () => {
      resetFilters();
    };
    $[5] = resetFilters;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  useEffect(t1, t2);
  let t3;
  if ($[8] !== handleClickHeartTab || $[9] !== heartCategory) {
    t3 = HeartTabList.map(item_0 => <ToggleButton key={item_0} checked={parseHeartCategory(item_0) === heartCategory} onChange={() => handleClickHeartTab(item_0)} className="text-[13px]">{item_0 === "all" ? "\uC804\uCCB4" : item_0}</ToggleButton>);
    $[8] = handleClickHeartTab;
    $[9] = heartCategory;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t3) {
    t4 = <div className="flex gap-7"><div className="flex gap-2.5">{t3}</div></div>;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
export default SignatureEmoticonFilterToggles;
function _temp(state) {
  return state.heartCategory;
}
function _temp2(state_0) {
  return state_0.minHeart;
}
function _temp3(state_1) {
  return state_1.maxHeart;
}
function _temp4(state_2) {
  return state_2.setState;
}
function _temp5(state_3) {
  return state_3.resetFilters;
}